import { useContext, useEffect, useState } from "react";
import { EnvironmentContext, environments } from "../../../config/EnvironmentContext";
import { useToken } from "./token";

const defaultOpts = {};
export const useDelete = (input, opts = defaultOpts, refreshFlag = true) => {
  const { token } = useToken();
  const [deleteError, setError] = useState(null);
  const [deleteLoading, setLoading] = useState(false);
  const [deleteData, setData] = useState(null);
  const { readBody = (body) => body.json() } = opts;
  const env = useContext(EnvironmentContext);
  const abortController = new AbortController();
  const signal = abortController.signal;

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    (async () => {
      setError(null);
      if (input && refreshFlag && token) {
        let url = environments.location[env] + input;
        setLoading(true);
        try {
          const response = await fetch(url, {
            method: "DELETE",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              Authorization: token.tokenType + " " + token.token,
            },
            signal: signal,
            mode: "cors",
          });
          if (response.ok) {
            const body = await readBody(response);
            setData(body);
            setError(null);
            setLoading(false);
          } else {
            const body = await readBody(response);
            // console.log(body);
            setError(body.message);
            setLoading(false);
          }
        } catch (e) {
          console.error("E", e);
          // setData([]);
          setError(e);
          setLoading(false);
        }
      }
    })();
  }, [input, opts, refreshFlag]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO
  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  return { deleteError, deleteLoading, deleteData };
};
